export const icons = {
  play: 'play',
  pause: 'pause',
  replay: 'replay',
  volume: 'volume-on',
  muted: 'volume-off',
}

export const convertSeconds = time => {
  const minutes = `0${Math.floor(time / 60)}`
  const seconds = `0${Math.floor(time - minutes * 60)}`

  return `${minutes.substr(-2)}:${seconds.substr(-2)}`
}

export const getPercent = (currentTime, duration) => {
  return currentTime / duration * 100
}

export const between = (a, b, c) => {
  const min = Math.min(a, b)
  const max = Math.max(a, b)

  return c > min && c < max
}
